import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OptimizedImage from '../components/OptimizedImage';
import { customerStories } from '../data/pagesData';
import { ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CustomersPage = () => {
  const [stories, setStories] = useState(customerStories);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API}/customer-stories`).then(r => r.json()).then(d => { if (d && d.length) setStories(d); }).catch(() => {});
  }, []);

  const featured = stories.find(s => s.featured);
  const others = stories.filter(s => !s.featured);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${API}/newsletter`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
      setSubscribed(true);
    } catch { setSubscribed(true); }
  };

  return (
    <div className="bg-[#F9FBF5] min-h-screen">
      <Navbar />
      <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-12">
        <h1 className="text-[#082900] text-[48px] lg:text-[72px] font-serif leading-tight mb-4">Customer Stories</h1>
        <p className="text-[#082900]/70 text-lg font-inter max-w-xl">How our customers are transforming their hiring processes</p>
      </section>

      {/* Featured Story */}
      {featured && (
        <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pb-16">
          <Link to={`/customer-stories/${featured.slug}`} className="block group">
            <div className="rounded-2xl overflow-hidden bg-[#EAE5D9]">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2"><OptimizedImage src={featured.image} alt={featured.title} className="w-full h-full object-cover aspect-[4/3]" priority={true} /></div>
                <div className="lg:w-1/2 p-8 lg:p-14 flex flex-col justify-center">
                  <span className="inline-block bg-[#082900] text-white text-xs font-semibold px-3 py-1 rounded-full font-inter mb-4 w-fit">Featured</span>
                  <span className="text-[#082900]/50 text-sm font-inter mb-2">Customers &middot; {featured.readTime}</span>
                  <h2 className="text-[#082900] text-[28px] lg:text-[36px] font-serif leading-tight mb-4 group-hover:underline">{featured.title}</h2>
                  <p className="text-[#082900]/70 text-base font-inter leading-relaxed mb-6">{featured.excerpt}</p>
                  <span className="inline-flex items-center gap-2 text-[#082900] text-sm font-semibold font-inter">Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </div>
            </div>
          </Link>
        </section>
      )}

      {/* Other Stories */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pb-20">
        <h2 className="text-[#082900] text-[28px] font-serif mb-8">Our latest stories</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {others.map((story, i) => (
            <Link key={i} to={`/customer-stories/${story.slug}`} className="block group">
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                <div className="aspect-[16/10] overflow-hidden"><OptimizedImage src={story.image} alt={story.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-5">
                  <span className="text-[#082900]/50 text-xs font-inter">Customers &middot; {story.readTime}</span>
                  <h3 className="text-[#082900] text-lg font-serif font-bold mt-2 mb-2 group-hover:underline">{story.title}</h3>
                  <p className="text-[#082900]/60 text-sm font-inter line-clamp-2">{story.excerpt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Newsletter */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pb-20">
        <div className="bg-[#EAE5D9] rounded-2xl p-8 lg:p-14 text-center">
          <h2 className="text-[#082900] text-[28px] font-serif mb-3">Stay ahead of the crowd</h2>
          <p className="text-[#082900]/60 text-base font-inter mb-6 max-w-lg mx-auto">Subscribe to get notified of exciting features, new products, and other recruiting news.</p>
          {subscribed ? <p className="text-[#4A6B3A] font-inter font-medium">Thank you! Your subscription has been received!</p> : (
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" className="flex-1 border border-[#082900]/20 rounded-full px-5 py-3 text-sm font-inter focus:outline-none focus:border-[#082900] bg-transparent" />
              <button type="submit" className="px-6 py-3 bg-[#082900] text-white text-sm font-medium rounded-full hover:bg-[#0A3900] transition-colors font-inter">Subscribe</button>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CustomersPage;
